import { render, staticRenderFns } from "./receiving-require.vue?vue&type=template&id=4014618c&scoped=true&"
import script from "./receiving-require.vue?vue&type=script&lang=js&"
export * from "./receiving-require.vue?vue&type=script&lang=js&"
import style0 from "./receiving-require.vue?vue&type=style&index=0&id=4014618c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4014618c",
  null
  
)

export default component.exports